import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// cn merges conditional class lists and de-dupes conflicting Tailwind utilities
// (so a later `px-6` wins over an earlier `px-4`). Used by every primitive.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
